import type React from 'react';

interface Props {
  visible?: boolean;
}

export const HiddenText: React.FC<React.PropsWithChildren<Props>> = (props) => {
  if (props.visible) {
    return (
      <span
        style={{
          backgroundColor: '#d8d8d8',
          display: 'inline-block',
          width: '84px',
          height: '8px',
        }}
      />
    );
  } else return <></>;
};
